export const RESULT_CARD_X_MARGIN_XXSMALL = 0;
export const RESULT_CARD_X_MARGIN_MEDIUM = 7;
export const RESULT_CARD_X_MARGIN_LARGE = 10;

export const RESULT_CARD_Y_MARGIN_XXSMALL = 8;
export const RESULT_CARD_Y_MARGIN_LARGE = 8;

export const REFINE_MAX_WIDTH = 288;
export const REFINE_ZINDEX = 100;

/**
 * if refine is toggled while the mobile map is open, it should appear above
 */
export const MOBILE_MAP_ZINDEX = REFINE_ZINDEX - 1;

export const MAP_WIDTH_S = '288px';
export const MAP_WIDTH_L = '300px';
export const MAP_WIDTH_XL = '33%';
export const MAP_WIDTH_XXXL = '50%';

export const HEADER_BAR_HEIGHT_XXSMALL = 48;
export const HEADER_BAR_HEIGHT_MEDIUM = 64;

export const HEADER_SEARCH_BAR_TOP_MARGIN = 16;

export const PAGE_SIZE = 10;
